if (document.querySelector('.slideOut__button')) {
  const slideOutButtons = document.querySelectorAll('.slideOut__button');
  const slideOutPanes = document.querySelectorAll('.slideOut__content');
  const slideOutOverlay = document.querySelector('.slideOut-overlay');
  const bodyElement = document.body;
  let scrollY = 0;

  const showDialog = () => {
    scrollY = window.scrollY;
    bodyElement.style.position = 'fixed';
    bodyElement.style.top = `-${scrollY}px`;
  };

  const closeDialog = () => {
    bodyElement.style.position = '';
    bodyElement.style.top = '';
    window.scrollTo(0, scrollY);
  };

  const togglePane = (index) => {
    slideOutPanes.forEach((pane, i) => {
      const isOpen = i === index && !pane.classList.contains('open');
      pane.classList.toggle('open', isOpen);
    });

    if (slideOutPanes[index].classList.contains('open')) {
      showDialog();
    } else {
      closeDialog();
    }

    slideOutOverlay.classList.toggle('open', slideOutPanes[index].classList.contains('open'));
  };

  const handleClick = (event) => {
    const targetPane = event.target.closest('.slideOut__content');
    const targetButton = event.target.closest('.slideOut__button');
    const closeButton = event.target.closest('.slideOut-btn_close');

   /* if (!targetPane && !targetButton) {
      closeAllPanels();
    }

    if (closeButton) {
      closePanel(closeButton);
    }*/
    if (!targetPane && !targetButton && slideOutOverlay.classList.contains('open')) {
      closeAllPanels();
    }
  
    if (closeButton) {
      closePanel(closeButton);
    }
  };

  const closeAllPanels = () => {
    slideOutPanes.forEach((pane) => {
      pane.classList.remove('open');
    });
    slideOutOverlay.classList.remove('open');
    closeDialog();
  };

  const closePanel = (closeButton) => {
    const openPane = closeButton.closest('.slideOut__content.open');
    if (openPane) {
      openPane.classList.remove('open');
      slideOutOverlay.classList.remove('open');
      closeDialog();
    }
  };

  document.addEventListener('click', handleClick);

  slideOutButtons.forEach((button, index) => {
    button.addEventListener('click', () => togglePane(index));
  });

}
